module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "calibre2"
  }, [_c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h1', {
    staticClass: "sgc-1 sigilNotInTOC",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("Dedication"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "calibre10 sgc-6"
  }, [_vm._v("For Mechthild Gawlick"), _c('br'), _vm._v("\n  Who turns to engage me unreservedly"), _c('br'), _vm._v("\n  On the “narrow ridge” of genuine dialogue.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9a0a918","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Dedication.vue
// module id = 69
// module chunks = 0